var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    fill: "#F87171",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2988 5.79414L14.3005 5.79425C15.9863 5.90506 17.4308 7.30003 17.618 9.07717L17.6182 9.07886C17.8245 10.9759 16.7051 12.8261 15.215 14.3875C13.742 15.931 12.0044 17.0888 11.1977 17.5864C11.0741 17.6617 10.9252 17.6617 10.8016 17.5864C9.99503 17.0889 8.25884 15.931 6.78647 14.3875C5.29712 12.8262 4.17736 10.9757 4.38124 9.07822L4.38135 9.07717C4.56836 7.30167 6.01145 5.91079 7.6992 5.79423C8.72696 5.72872 9.66537 6.1073 10.354 6.77231C10.7147 7.12182 11.2837 7.12206 11.6446 6.77302C12.3417 6.10485 13.2753 5.72352 14.2988 5.79414Z",
    fill: "white",
    stroke: "#991B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.52bf003b2878e242dc410d4405765a28.svg";
export { ForwardRef as ReactComponent };